// 多语种配置
export default {
  // 语种配置项
  // 如需新增语种，只需在此处增加一项配置，然后在@src/common/lang/目录下新增对应的语种资源文件即可，不需要再修改其他配置
  LANGUAGE_MAP: {
    // 中文
    'zh_CN': {
      // 中文本地文本资源路径，路径存放为：@src/common/lang/zh.js
      localI18n: 'zh',
      // elementUi组件中的中文文本资源路径，路径存放为：element-ui/lib/locale/lang/zh-CN.js
      elI18n: 'zh-CN',
      // 语种展示名称，此处不需要使用国际化配置，配置对应语种的文本即可
      name: '简体中文'
    },
    // 英文
    'en_US': {
      localI18n: 'en',
      elI18n: 'en',
      name: 'English'
    }
  },
  // 系统默认语种，该值必须与LANGUAGE_MAP中key值一致
  DEFAULT_LANGUAGE: 'zh_CN'
}